import { ReactNode } from "react";

interface TranslationStrings {
    // DonoTrain Ready
    DONO_TRAIN_IS_READY: ReactNode;

    // DonoTrain Primed
    DONO_TRAIN_IS_PRIMED: ReactNode;
    DONO_TRAIN_START_CONDITION: ReactNode;

    // DonoTrain InProgress
    DONO_TRAIN_IN_PROGRESS: ReactNode;
    DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL_PRE: ReactNode;
    DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL: ReactNode;

    // DonoTrain Cooldown
    DONO_TRAIN_COOLDOWN: ReactNode;

    // DonoTrain Finished
    DONO_TRAIN_FINISHED: ReactNode;
}

interface Translations {
    de: TranslationStrings;
    en: TranslationStrings;
}

export const translations: Translations = {
    de: {
        DONO_TRAIN_IS_READY: <span style={{ marginLeft: "5px" }}>Hype Train ist <span style={{ color: "limegreen" }}>READY</span>!</span>,
        DONO_TRAIN_IS_PRIMED: <span style={{ marginLeft: "5px" }}>Hype Train<br/><span style={{ color: "orange" }}>nähert sich</span> !</span>,
        DONO_TRAIN_IN_PROGRESS: <span style={{ marginLeft: "5px" }}>Hype Train</span>,
        DONO_TRAIN_START_CONDITION: "Noch 1 Donation / 1 Sub / 100 Bits zum Starten!",
        DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL_PRE: "Noch",
        DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL: "bis zum nächsten Level",
        DONO_TRAIN_COOLDOWN: <span style={{ marginLeft: "5px" }}>Hype Train <span style={{ color: "red" }}>COOLDOWN</span>!</span>,
        DONO_TRAIN_FINISHED: <span className="train-color">BANGER Support!</span>,
    },
    en: {
        DONO_TRAIN_IS_READY: <span style={{ marginLeft: "5px" }}>Hype Train is <span style={{ color: "limegreen" }}>READY</span>!</span>,
        DONO_TRAIN_IS_PRIMED: <span style={{ marginLeft: "5px" }}>Hype Train<br/><span style={{ color: "orange" }}>is approaching</span> !</span>,
        DONO_TRAIN_IN_PROGRESS: <span style={{ marginLeft: "5px" }}>Hype Train</span>,
        DONO_TRAIN_START_CONDITION: "Just 1 more Donation / 1 Sub / 100 Bits to start!",
        DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL_PRE: "Just",
        DONO_TRAIN_AMOUNT_UNTIL_NEXT_LEVEL: "until next Level",
        DONO_TRAIN_COOLDOWN: <span style={{ marginLeft: "5px" }}>Hype Train <span style={{ color: "red" }}>COOLDOWN</span>!</span>,
        DONO_TRAIN_FINISHED: <span className="train-color">BANGER Support!</span>,
    }
}

export const translate = <T extends keyof TranslationStrings>(prop: T): TranslationStrings[T] => {
    const language = import.meta.env.VITE_LANGUAGE;
    return translations[language][prop];
}

type InlineTranslation = {
    [language in keyof Translations]: ReactNode;
};
export const inlineTranslate = (data: InlineTranslation) => {
    const language = import.meta.env.VITE_LANGUAGE;

    return data[language]
}